import {Injectable} from '@angular/core';
import {Http} from '@angular/http';

import 'rxjs/add/operator/toPromise';

@Injectable()
export class StockArticleService {
    private api_url_get_articles = './api/server.php?cmd=SEARCH_ARTICLES';
    private api_url_get_articles_transfer = './api/server.php?cmd=SEARCH_ARTICLES_TRANSFER';

    constructor(private http: Http) {}

    getArticles(name: string): Promise<any> {
        return this.http.get(this.api_url_get_articles
            + '&internal_code=undefined'
            + '&reference_code=undefined'
            + '&name=' + name
            + '&category=root'
        )
            .toPromise()
            .then(response => response.json() as any)
            .catch(this.handleError);
    }

    getArticlesTransfer(warehouse: string, name: string): Promise<any> {
        return this.http.get(this.api_url_get_articles_transfer
            + '&internal_code=undefined'
            + '&reference_code=undefined'
            + '&name=' + name
            + '&category=root'
            + '&warehouse=' + warehouse
        )
            .toPromise()
            .then(response => response.json() as any)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// ./src/app/stock-article.service.ts